export function getOrderDoneResults(data) {
  return Array.isArray(data?.results) ? data.results : [];
}

export function formatOrderDoneDate(value) {
  if (!value) return "-";
  return String(value).slice(0, 10);
}

export function getTicketDoneQuantity() {
  return "1";
}

export const ACTIVE_TODAY_RESERVATION_STATES = new Set(["예약", "입장", "외출"]);

export function formatLocalDate(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function normalizeOrderDoneDate(value) {
  if (!value) return "";
  return String(value).slice(0, 10);
}

export function getOrderRuleSections(order) {
  const sections = [
    { key: "using_info", title: "이용안내", html: order?.using_info },
    { key: "instruction", title: "유의사항", html: order?.instruction },
  ];

  return sections
    .map((section) => ({
      ...section,
      html: typeof section.html === "string" ? section.html.trim() : "",
    }))
    .filter((section) => section.html.length > 0);
}

function getReservationRuleIdentity(order) {
  if (order?.package_id !== undefined && order?.package_id !== null) {
    return `package:${order.package_id}`;
  }
  return `name:${order?.name || "예약상품"}`;
}

export function getReservationRules(orders, options = {}) {
  const { requireActiveState = false } = options;
  const seenRuleIdentities = new Set();

  return (orders || []).reduce((items, order) => {
    const state = order?.state || "";
    const sections = getOrderRuleSections(order);
    const ruleIdentity = getReservationRuleIdentity(order);

    if (
      sections.length > 0 &&
      (!requireActiveState || ACTIVE_TODAY_RESERVATION_STATES.has(state)) &&
      !seenRuleIdentities.has(ruleIdentity)
    ) {
      seenRuleIdentities.add(ruleIdentity);
      items.push({
        id: order?.id,
        ruleIdentity,
        name: order?.name || "예약상품",
        spot: order?.spot || "",
        reservationDate: normalizeOrderDoneDate(order?.reservationDate),
        sections,
      });
    }

    return items;
  }, []);
}

export function buildReservationRulesDismissKey(userId, date, rules) {
  const normalizedUserId = userId ?? "guest";
  const reservationIds = Array.from(
    new Set((rules || []).map((rule) => rule?.id ?? "unknown")),
  ).sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }));

  return `same-day-rules:${normalizedUserId}:${date}:${reservationIds.join(",") || "unknown"}`;
}

export function buildSameDayReservationRulesDismissKey(userId, orders, referenceDate = new Date()) {
  const today = typeof referenceDate === "string" ? referenceDate : formatLocalDate(referenceDate);
  const sameDayRules = getSameDayReservationRules(orders, today);

  if (!sameDayRules.length) return "";
  return buildReservationRulesDismissKey(userId, today, sameDayRules);
}

export function getSameDayReservationRules(orders, referenceDate = new Date()) {
  const today = typeof referenceDate === "string" ? referenceDate : formatLocalDate(referenceDate);

  return getReservationRules(orders, { requireActiveState: true }).reduce((items, order) => {
    const reservationDate = normalizeOrderDoneDate(order?.reservationDate);

    if (reservationDate === today) {
      items.push(order);
    }

    return items;
  }, []);
}
